// extracted by mini-css-extract-plugin
export default {"root":"vyJqD","spinner":"QHhZ4","title":"O6Qdn"};